import React, { useContext } from "react";
import VGaurdLogo from "../../../assets/images/logoLogin.svg";
import LoginBanner from "../../../assets/images/loginBanner.svg";
import TextInput from "../../../components/TextInputComponent/TextInput";
import "./loginResetPasword.css";
import Button from "../../../components/ButtonComponent/Button";
import EyeVisible from "../../../assets/images/eyeVisible.svg";
import EyeInVisible from "../../../assets/images/eyeInVisible.svg";
import { ResetPasswordContext } from "../LoginResetPasswordView";
import { Col, Row } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
const ResetPasswordPage = ({ textContents }) => {
  const {
    buttonUpdateClick,
    newPassword,
    setNewPassword,
    confirmPassword,
    setconfirmPassword,
    newPasswordType,
    setNewPasswordType,
    confirmPasswordType,
    alertMessage,
    setConfirmPasswordType,
    passWordMisMatch,
    emptyNewPassword,
    emptyConfirmPassword,
    showAlert,
    setShowAlert,
    navigateToLogin,
  } = useContext(ResetPasswordContext);

  return (
    <>
      <Row>
        <Col lg={6} className="resetDiv">
          <div className="resetMainContainer">
            <div className="resetPasswordVgaurdLogo">
              <img src={VGaurdLogo} />
            </div>
            <div className="container resetAccountContainer">
              <div className="colwelcome">
                <div className="row align-self-start resetTopPasswordText">
                  {textContents.resetPassword}
                </div>
              </div>
            </div>

            <form className="resetItemFormSection">
              <div className="form-group">
                <label className="row align-self-start newPasswordText">
                  {textContents.newPassword}
                </label>
                <div className="newpasswordInput">
                  <TextInput
                    placeholder="New Password"
                    type={newPasswordType}
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                    }}
                  />
                  {emptyNewPassword ? (
                    <div className="invalid-text">
                      {textContents.newPasswordWarning}
                    </div>
                  ) : (
                    ""
                  )}
                  {newPasswordType === "password" ? (
                    <i className="bi bi-eye-slash">
                      <img
                        src={EyeVisible}
                        onClick={() => {
                          setNewPasswordType("text");
                        }}
                      />
                    </i>
                  ) : (
                    <i className="bi bi-eye-slash">
                      <img
                        src={EyeInVisible}
                        onClick={() => {
                          setNewPasswordType("password");
                        }}
                      />
                    </i>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="row align-self-start resetConfirmText">
                  {textContents.comfirmPassword}
                </label>
                <div className="passwordInput">
                  <TextInput
                    placeholder="Confirm password"
                    type={confirmPasswordType}
                    value={confirmPassword}
                    onChange={(e) => {
                      setconfirmPassword(e.target.value);
                    }}
                  />
                  {emptyConfirmPassword ? (
                    <div className="invalid-text">
                      {textContents.confimPasswordWarning}
                    </div>
                  ) : (
                    ""
                  )}
                  {confirmPasswordType === "password" ? (
                    <i className="bi bi-eye-slash">
                      <img
                        src={EyeVisible}
                        onClick={() => {
                          setConfirmPasswordType("text");
                        }}
                      />
                    </i>
                  ) : (
                    <i className="bi bi-eye-slash">
                      <img
                        src={EyeInVisible}
                        onClick={() => {
                          setConfirmPasswordType("password");
                        }}
                      />
                    </i>
                  )}
                </div>
                <div>
                  <div className="d-flex mb-3">
                    <div className="p-1">
                      {passWordMisMatch ? (
                        <div className="invalid-text">
                          {textContents.passwordMismatch}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="buttonResetUpdate">
                <Button
                  text="UPDATE"
                  onClick={() => {
                    buttonUpdateClick();
                  }}
                />
              </div>
            </form>
            <AlertBox
              show={showAlert}
              setShow={setShowAlert}
              alertMessage={alertMessage}
              buttonSubmitText={"OK"}
              handleSubmit={() => {
                navigateToLogin();
              }}
            />
          </div>
        </Col>
        <Col lg={6} className="resetBannerDiv">
          <img className="resetImagBanner" src={LoginBanner} />
        </Col>
      </Row>
    </>
  );
};
export default ResetPasswordPage;
